import React from 'react'

export default function Footer() {
  return (
    <div>
        <footer style={{textAlign : 'center'}} >Thank You God , Thanks for everything</footer>
    </div>
  )
}
